import { React, useState, useEffect } from "react";
import "./Profile.css";
function Profile() {
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [selectedImage, setSelectedImage] = useState(null);
  const [profilePic, setProfilePic] = useState(
    localStorage.getItem("profilePic") ||
      "https://avatars.githubusercontent.com/u/561701800?v=4"
  );
  useEffect(() => {
    localStorage.setItem("profilePic", profilePic);
  }, [profilePic]);
  useEffect(() => {
    localStorage.setItem("profilePic", profilePic);
  }, [profilePic]);
  const [isSignIn, setIsSignIn] = useState(
    localStorage.getItem("isSignIn") === "true" || false
  );
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  const [bio, setBio] = useState(localStorage.getItem("bio") || "");
  const [password, setPassword] = useState(
    localStorage.getItem("password") || ""
  );
  const [followers, setFollowers] = useState(0);
  const [following, setFollowing] = useState(0);
  const [posts, setPosts] = useState(0);
  const jumpToHome = () => {
    window.location.href = "/Home";
  };
  const [edit, setEdit] = useState(false);

  const handleEdit = () => {
    setEdit(!edit);
  };

  const handleImageUpload = async () => {
    const formData = new FormData();
    formData.append("file", selectedImage);
    formData.append("upload_preset", "recipe_profile_uploads");
    formData.append("api_key", "416933163966276");

    try {
      const response = await fetch(
        "https://api.cloudinary.com/v1_1/dqg3prhwt/image/upload",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await response.json();
      setProfilePic(data.url);
    } catch (error) {
      console.error("Failed to upload image:", error);
    }
  };

  const onFileChange = (event) => {
    setSelectedImage(event.target.files[0]);
    if (event.target.files[0]) {
      handleImageUpload();
    }
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <h1>Chef's Kiss</h1>
          </div>
          <div className="navbar-user">
            <button
              className="btn btn-user"
              onClick={() => {
                jumpToHome();
              }}
            >
              Home
            </button>
            <button
              className="btn btn-logout"
              onClick={() => {
                setIsSignIn(false);
                setEmail("");
                setUsername("");
                window.location.href = "/";
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      {edit ? (
        <div className="profile-container">
          <div className="profile-card">
            <div className="profile">
              <div className="profile-image">
                <img src={profilePic} alt="profile" />
              </div>
              <input type="file" onChange={onFileChange} />
            </div>
            <div className="profile-user-settings">
              <h1 className="profile-user-name">
                <label htmlFor="username">Username: </label>
                <input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </h1>
            </div>
            <div className="profile-bio">
              <div className="bio">
                <label htmlFor="bio">Bio: </label>
                <textarea
                  value={bio}
                  onChange={(e) => setBio(e.target.value)}
                />
              </div>
            </div>
            <button onClick={handleEdit} className="btn profile-edit-btn">
              Save Profile
            </button>
          </div>
        </div>
      ) : (
        <div className="profile-container">
          <div className="profile-card">
            <div className="profile">
              <div className="profile-image">
                <img src={profilePic} alt="profile" />
              </div>
            </div>
            <div className="profile-user-settings">
              <h1 className="profile-user-name">{username}</h1>
            </div>
            <div className="profile-stats">
              <ul>
                <li>
                  <span className="profile-stat-count">{posts}</span> posts
                </li>
                <li>
                  <span className="profile-stat-count">{followers}</span>{" "}
                  followers
                </li>
                <li>
                  <span className="profile-stat-count">{following}</span>{" "}
                  following
                </li>
              </ul>
            </div>
            <div className="profile-bio">
              <div className="bio">{bio}</div>
            </div>
            <button onClick={handleEdit} className="btn profile-edit-btn">
              Edit Profile
            </button>
          </div>
        </div>
      )}
    </>
  );
}
export default Profile;
